import { input, output, TODO } from '@b2b/types/core';
import { WillCallOrderItemsByEventVo } from '@b2b/types/order/api/will-call-order-detail.type';
import uiRouter from '@uirouter/angularjs';
import angular from 'angular';

interface OrderServiceType {
  getItemType: (type: string, subType?: string) => string;
}

interface AddonFeeItem {
  orderItemId?: string;
  itemType?: string;
  itemTypeId?: string;
  itemTypeName?: string;
  quantity?: number;
  resolvedQuantity?: number;
  unitPrice?: string | number;
  discountedUnitPrice?: string | number;
  subtotal?: string | number;
  discountedSubtotal?: string | number;
  refundable?: boolean;
}

class ExistingOrderAddonsAndFeesController {
  static $inject = ['$element', 'OrderService'];

  event = input<WillCallOrderItemsByEventVo>()!;
  onRemoveItemQuantity = output<{ item: AddonFeeItem; itemIndex: number }>();

  constructor(
    private $element: JQuery,
    private orderService: OrderServiceType,
  ) {}

  $onInit() {
    this.$element.addClass('acme-existing-order-addons-and-fees');
  }

  getItemType(itemType: string): string {
    return this.orderService.getItemType(itemType);
  }

  isFee(item: AddonFeeItem): boolean {
    return item.itemType === 'Fee';
  }

  canRemove(item: AddonFeeItem): boolean {
    return !this.isFee(item);
  }

  handleRemoveItemQuantity(item: AddonFeeItem, itemIndex: number): void {
    this.onRemoveItemQuantity({ $event: { item, itemIndex } });
  }

  hasRefundableFee(): boolean {
    return this.event.items.some(item => this.isFee(item) && item.refundable);
  }

  hasNonRefundableFee(): boolean {
    return this.event.items.some(item => this.isFee(item) && !item.refundable);
  }
}

export const ExistingOrderAddonsAndFeesComponentModule = angular
  .module('acme.view.application.orders.edit.components.existing-order-addons-and-fees', [
    uiRouter,
    'acme.common.service.order',
    'acme.common.directive.minus',
  ])
  .component('acmeExistingOrderAddonsAndFees', {
    templateUrl: `views/application/views/orders/edit/components/existing-order-addons-and-fees/existing-order-addons-and-fees.component.tpl.html`,
    controller: ExistingOrderAddonsAndFeesController,
    controllerAs: '$ctrl',
    bindings: {
      event: '<',
      onRemoveItemQuantity: '&',
    },
  }).name;
